var render = function (_h,_vm) {var _c=_vm._c;return _c('td',[_c('button',[_c('Icon',{staticClass:"icon",attrs:{"icon":_vm.props.active ? 'pause' :'play'}}),_c('span',{staticClass:"number"},[_vm._v(_vm._s(_vm.props.track.track || 1))])],1)])}
var staticRenderFns = []

export { render, staticRenderFns }